'use strict';

var privatePropertyAccessor = require('../internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('utc');


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/_utc.js
// module id = 21
// module chunks = 1